export const translations = {
  en: {
    nav: {
      work: "Work",
      services: "Services",
      manifesto: "Manifesto",
      team: "Team",
      contact: "Contact",
      cta: "Start a project",
    },
    hero: {
      eyebrow: "A multidisciplinary collective — Est. Everywhere",
      line1: "We build",
      line2: "worlds around",
      line3: "brands.",
      tagline:
        "HK Brand Lab is a multi-ethnic creative studio operating at the intersection of branding, digital content, interior design, fashion, music and marketing.",
      scroll: "Scroll to enter",
    },
    marquee: {
      words: ["Branding", "Interior Design", "Fashion", "Music", "Digital Content", "Marketing", "Graphic Design"],
    },
    manifesto: {
      label: "01 — Manifesto",
      title: "Six disciplines,\none obsession:\nthe next idea.",
      chapters: [
        {
          n: "01",
          title: "We are not an agency.",
          body: "We are a rotating collective of designers, architects, musicians, stylists and strategists from four continents — assembled for the brief, not for the org chart.",
        },
        {
          n: "02",
          title: "Craft over quantity.",
          body: "One project, obsessed over. Then the next. We ship fewer things, on purpose. Every deliverable earns the studio's name on it.",
        },
        {
          n: "03",
          title: "Culture is the medium.",
          body: "A campaign, a chair, a track, a wall of concrete: all of these are language. We work across surfaces because our clients live across them too.",
        },
        {
          n: "04",
          title: "Multi-ethnic by default.",
          body: "Our fluency is not a diversity statement — it's a design tool. We speak six languages in the studio and think in more.",
        },
      ],
    },
    services: {
      label: "02 — Services",
      title: "What we build.",
      items: [
        { id: "branding", name: "Branding", desc: "Identity systems, verbal identity, brand books, launch strategy." },
        { id: "digital", name: "Digital Content", desc: "Editorial content, campaigns, art direction for social, film & photography." },
        { id: "interior", name: "Interior Design", desc: "Retail interiors, flagship stores, private residences, F&B spaces." },
        { id: "fashion", name: "Fashion", desc: "Collection direction, lookbooks, brand collaborations, styling." },
        { id: "music", name: "Music", desc: "Sonic identity, original scoring, music supervision, artist direction." },
        { id: "marketing", name: "Marketing", desc: "Go-to-market strategy, paid media, growth systems, launches." },
        { id: "graphic", name: "Graphic Design", desc: "Print, editorial, packaging, motion, type systems." },
      ],
    },
    portfolio: {
      label: "03 — Selected work",
      title: "In practice.",
      view: "View case",
      items: [
        { title: "Aria Flagship, Milano", client: "Aria Studios", tag: "Interior · Retail", year: "2024" },
        { title: "Kōgetsu SS25", client: "Kōgetsu", tag: "Fashion · Direction", year: "2025" },
        { title: "Field Notes Vol.4", client: "Zephyr Records", tag: "Music · Identity", year: "2024" },
        { title: "House on the Ridge", client: "Private", tag: "Interior · Residential", year: "2023" },
        { title: "Meridian Rebrand", client: "Meridian", tag: "Branding · Digital", year: "2025" },
        { title: "Ephemera Campaign", client: "Ephemera", tag: "Content · Fashion", year: "2024" },
      ],
    },
    team: {
      label: "04 — The collective",
      title: "The people\nin the room.",
      intro:
        "A cross-continental collective spanning music, design, branding and business. We hire for craft first, culture always.",
      members: [
        {
          name: "Gordon Santoro",
          role: "Music Composer / Record Producer / Music Executive",
          origin: "Dubai / AE",
          image: "https://customer-assets-39nsmqrw.emergentagent.net/job_digital-creative-6/artifacts/ch6f27ye_Gordon.jpg",
          link: "https://www.yumenoyapublishing.com",
        },
        {
          name: "Ottavio Luggin",
          role: "Creative Direction / Designer",
          origin: "APAC",
          image: "https://customer-assets-39nsmqrw.emergentagent.net/job_digital-creative-6/artifacts/vwf0tftn_Ottavio.jpg",
          link: "https://www.ottavioluggin.com/",
        },
        {
          name: "Barook Farrukh",
          role: "Business Developer / Design & Branding",
          origin: "Macau SAR",
          image: "https://customer-assets-39nsmqrw.emergentagent.net/job_digital-creative-6/artifacts/wxvors23_Barook.jpg",
          link: "https://www.barookfarrukh.com/",
        },
        {
          name: "Douglas Ting",
          role: "Commercial Director",
          origin: "Hong Kong / CN",
          image: "https://customer-assets-39nsmqrw.emergentagent.net/job_digital-creative-6/artifacts/s0h10ynk_Douglas.jpg",
          link: "https://www.linkedin.com/in/douglas-ting",
        },
      ],
    },
    contact: {
      label: "05 — Say hello",
      title: "Let's\ntalk.",
      subtitle:
        "Have a brief, a hunch, or a wild question? We reply to every message within 48 hours.",
      form: {
        name: "Your name",
        email: "Email",
        company: "Company (optional)",
        service: "Interested in",
        budget: "Budget",
        message: "Tell us about the project",
        submit: "Send message",
        sending: "Sending…",
        success: "Message received. We'll be in touch within 48 hours.",
        error: "Something went wrong. Please try again.",
      },
      budgetOptions: ["Under €10k", "€10k–€30k", "€30k–€80k", "€80k+", "Let's discuss"],
    },
    footer: {
      studio: "Studio",
      contact: "Contact",
      social: "Social",
      colophon: "Set in Bricolage Grotesque & Manrope. Built with intent.",
      rights: "All rights reserved.",
    },
  },
  it: {
    nav: {
      work: "Lavori",
      services: "Servizi",
      manifesto: "Manifesto",
      team: "Team",
      contact: "Contatti",
      cta: "Inizia un progetto",
    },
    hero: {
      eyebrow: "Un collettivo multidisciplinare — Ovunque",
      line1: "Costruiamo",
      line2: "mondi intorno",
      line3: "ai brand.",
      tagline:
        "HK Brand Lab è uno studio creativo multietnico che opera all'incrocio tra branding, contenuti digitali, interior design, moda, musica e marketing.",
      scroll: "Scorri per entrare",
    },
    marquee: {
      words: ["Branding", "Interior Design", "Moda", "Musica", "Contenuti Digitali", "Marketing", "Grafica"],
    },
    manifesto: {
      label: "01 — Manifesto",
      title: "Sei discipline,\nuna sola ossessione:\nla prossima idea.",
      chapters: [
        {
          n: "01",
          title: "Non siamo un'agenzia.",
          body: "Siamo un collettivo che ruota — designer, architetti, musicisti, stylist e strateghi da quattro continenti, montati sul brief, non sull'organigramma.",
        },
        {
          n: "02",
          title: "Cura, non quantità.",
          body: "Un progetto alla volta, curato in modo ossessivo. Poi il prossimo. Facciamo meno cose, di proposito. Ogni consegna si merita il nome dello studio.",
        },
        {
          n: "03",
          title: "La cultura è il nostro mezzo.",
          body: "Una campagna, una sedia, un brano, una parete in cemento: sono tutti linguaggio. Lavoriamo tra le superfici perché i nostri clienti ci vivono in mezzo.",
        },
        {
          n: "04",
          title: "Multietnici, per default.",
          body: "La nostra fluidità non è una dichiarazione di diversity — è uno strumento di design. Parliamo sei lingue nello studio e pensiamo in molte di più.",
        },
      ],
    },
    services: {
      label: "02 — Servizi",
      title: "Cosa costruiamo.",
      items: [
        { id: "branding", name: "Branding", desc: "Sistemi d'identità, tone of voice, brand book, strategie di lancio." },
        { id: "digital", name: "Contenuti Digitali", desc: "Contenuti editoriali, campagne, direzione artistica per social, film e fotografia." },
        { id: "interior", name: "Interior Design", desc: "Retail, flagship store, residenze private, spazi F&B." },
        { id: "fashion", name: "Moda", desc: "Direzione delle collezioni, lookbook, collaborazioni, styling." },
        { id: "music", name: "Musica", desc: "Identità sonora, colonne originali, music supervision, artist direction." },
        { id: "marketing", name: "Marketing", desc: "Strategia go-to-market, paid media, sistemi di crescita, lancio." },
        { id: "graphic", name: "Grafica", desc: "Stampa, editoriale, packaging, motion, sistemi tipografici." },
      ],
    },
    portfolio: {
      label: "03 — Lavori selezionati",
      title: "In pratica.",
      view: "Vedi caso",
      items: [
        { title: "Aria Flagship, Milano", client: "Aria Studios", tag: "Interior · Retail", year: "2024" },
        { title: "Kōgetsu SS25", client: "Kōgetsu", tag: "Moda · Direzione", year: "2025" },
        { title: "Field Notes Vol.4", client: "Zephyr Records", tag: "Musica · Identità", year: "2024" },
        { title: "House on the Ridge", client: "Privato", tag: "Interior · Residenziale", year: "2023" },
        { title: "Meridian Rebrand", client: "Meridian", tag: "Branding · Digitale", year: "2025" },
        { title: "Ephemera Campaign", client: "Ephemera", tag: "Contenuti · Moda", year: "2024" },
      ],
    },
    team: {
      label: "04 — Il collettivo",
      title: "Le persone\nin studio.",
      intro:
        "Un collettivo cross-continentale che unisce musica, design, branding e business. Selezioniamo prima il talento, sempre la cultura.",
      members: [
        {
          name: "Gordon Santoro",
          role: "Music Composer / Record Producer / Music Executive",
          origin: "Dubai / AE",
          image: "https://customer-assets-39nsmqrw.emergentagent.net/job_digital-creative-6/artifacts/ch6f27ye_Gordon.jpg",
          link: "https://www.yumenoyapublishing.com",
        },
        {
          name: "Ottavio Luggin",
          role: "Creative Direction / Designer",
          origin: "APAC",
          image: "https://customer-assets-39nsmqrw.emergentagent.net/job_digital-creative-6/artifacts/vwf0tftn_Ottavio.jpg",
          link: "https://www.ottavioluggin.com/",
        },
        {
          name: "Barook Farrukh",
          role: "Business Developer / Design & Branding",
          origin: "Macau SAR",
          image: "https://customer-assets-39nsmqrw.emergentagent.net/job_digital-creative-6/artifacts/wxvors23_Barook.jpg",
          link: "https://www.barookfarrukh.com/",
        },
        {
          name: "Douglas Ting",
          role: "Commercial Director",
          origin: "Hong Kong / CN",
          image: "https://customer-assets-39nsmqrw.emergentagent.net/job_digital-creative-6/artifacts/s0h10ynk_Douglas.jpg",
          link: "https://www.linkedin.com/in/douglas-ting",
        },
      ],
    },
    contact: {
      label: "05 — Scrivici",
      title: "Parliamo.",
      subtitle:
        "Hai un brief, un'intuizione o una domanda folle? Rispondiamo a ogni messaggio entro 48 ore.",
      form: {
        name: "Nome",
        email: "Email",
        company: "Azienda (opzionale)",
        service: "Sei interessato a",
        budget: "Budget",
        message: "Raccontaci del progetto",
        submit: "Invia messaggio",
        sending: "Invio in corso…",
        success: "Messaggio ricevuto. Ti ricontattiamo entro 48 ore.",
        error: "Qualcosa è andato storto. Riprova.",
      },
      budgetOptions: ["Meno di €10k", "€10k–€30k", "€30k–€80k", "€80k+", "Da discutere"],
    },
    footer: {
      studio: "Studio",
      contact: "Contatti",
      social: "Social",
      colophon: "Composto in Bricolage Grotesque & Manrope. Costruito con intenzione.",
      rights: "Tutti i diritti riservati.",
    },
  },
};
